<template>
  <SmartButton class="mr" v-for="i in opts" :key="i.k" :click="i.click" v-bind="i">{{ lang(i.label) }}</SmartButton>
</template>
<script setup lang="tsx" name="SmartButtonList">
import SmartButton from '../smart-button/index.vue'
import { computed, inject, type PropType } from 'vue'
const lang = inject('lang')
const hasPower = inject('hasPower')

const props = defineProps({
  options: {
    type: Array as PropType<Record<any, any>[]>,
    default: () => []
  }
})

const opts = computed(() =>
  props.options
    .filter((i) => {
      if (i.power) {
        return i.display !== false && hasPower(i.power) === true
      }
      return i.display !== false
    })
    .map((i, k) => ({ ...i, k: k }))
)
</script>
<style>
.mr {
  margin-right: 10px;
}
</style>
